import * as Sentry from '@sentry/browser'
import { useEffect } from 'react'

const envStage = process.env.NEXT_PUBLIC_ENV_STAGE || 'development'

// Create dynamic release name
const getReleaseName = () => {
  const timestamp = new Date().toISOString().split('T')[0] // YYYY-MM-DD format
  return `zen-web-app@${envStage}-${timestamp}`
}

export function SentryInit() {
  useEffect(() => {
    // Only initialize Sentry in production environment
    if (process.env.NODE_ENV === 'production') {
      const dsn = process.env.NEXT_PUBLIC_SENTRY_DNS

      // Validate DSN before initializing
      if (!dsn) {
        console.warn('Sentry DSN not found. Skipping Sentry initialization.')
        return
      }

      const releaseName = getReleaseName()

      try {
        Sentry.init({
          dist: 'zen-web-app-v2',

          dsn,

          environment: envStage,

          release: releaseName,

          replaysOnErrorSampleRate: 1.0,

          replaysSessionSampleRate: 0.1,

          tracesSampleRate: 0.1
        })
      } catch (error) {
        console.error('Failed to initialize Sentry:', error)
      }
    }
  }, [])

  return null
}
